import React, { useState, useEffect } from "react";
import api from "../../setupMiddleware";
import { getUser } from "../../Utils/auth";
import Loader from "../Loader/Loader";
import useApiLoader from "../../Utils/useApiLoader";
import { ToastContainer, toast, Bounce } from "react-toastify";
import LeaveApproveTable from "../Common/LeaveApproveTable";

const LeaveRequests = () => {
  const loading = useApiLoader();
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [requestOpen, setRequestOpen] = useState(false);
  const [requestRejectOpen, setRequestRejectOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [rejectReasonError, setRejectReasonError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const getPendingLeave = async () => {
    try {
      await api.get(`/api/leaves/get-requests`).then((res) => {
        if (res && res.status === 200) {
          setLeaveRequests(res.data?.data);
        }
      });
    } catch (error) {
      alert("Something went wrong!");
    }
  };

  const aproveLeave = async (leave_id) => {
    try {
      await api.post(`/api/leaves/${leave_id}/approve`).then((res) => {
        if (res && res.status === 200) {
          if (res.data.status) {
            toast.success(res.data?.message, {
              position: "top-left",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              transition: Bounce,
            });
          } else {
            toast.error(res.data?.message, {
              position: "top-left",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              transition: Bounce,
            });
          }
          setRequestOpen(false);
          getPendingLeave();
        }
      });
    } catch (error) {
      toast.success(error?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    }
  };

  const rejectLeave = async (leave_id) => {
    setSubmitted(true);
    if (!rejectReason) {
      setRejectReasonError("Please type Reason to reject leave.");
      return;
    }
    try {
      await api
        .post(`/api/leaves/${leave_id}/reject`, { reject_reason: rejectReason })
        .then((res) => {
          if (res && res.status === 200) {
            if (res.data.status) {
              toast.success(res.data?.message, {
                position: "top-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Bounce,
              });
            } else {
              toast.error(res.data?.message, {
                position: "top-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Bounce,
              });
            }
            setRequestRejectOpen(false);
            getPendingLeave();
            setSubmitted(false);
          }
        });
    } catch (error) {
      toast.success(error?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
      setSubmitted(false);
      setRejectReasonError("");
    }
  };

  useEffect(() => {
    getPendingLeave();
  }, []);

  // automatically clear error after 5 seconds
  useEffect(() => {
    if (rejectReasonError) {
      const timer = setTimeout(() => {
        setRejectReasonError("");
      }, 5000); // 5s

      // cleanup if message changes before 5s
      return () => clearTimeout(timer);
    }
  }, [rejectReasonError]);

  return (
    <>
      {loading && <Loader fullscreen opacity={90} />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            Leave Requests
          </span>
          <span className="block text-sm text-[#142b70]/50">
            Approve or Reject leave requests
          </span>
        </p>
      </div>
      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="w-full mx-auto px-4 py-3 relative rounded-xl bg-white border border-[#a48572]/10">
          <div className="flex flex-col justify-start items-start gap-[20px]">
            <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 relative gap-5">
              {/* <p className="flex-grow-0 flex-shrink-0 text-base font-medium text-left text-[#142b70]">
                Leave Requests
              </p> */}
            </div>
            <LeaveApproveTable
              data={leaveRequests}
              handleApprove={aproveLeave}
              handleReject={rejectLeave}
              requestOpen={requestOpen}
              setRequestOpen={setRequestOpen}
              requestRejectOpen={requestRejectOpen}
              setRequestRejectOpen={setRequestRejectOpen}
              reject_reason={rejectReason}
              setRejectReason={setRejectReason}
              error={rejectReasonError}
              submitted={submitted}
            />
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default LeaveRequests;
